import api from "@/service/api";

export default {
  namespaced: true,
  state: () => ({
    getIndexCompositionDataList: [],
    getIndexCompositionDataObj: {
      total: 0,
      pageNo: 1, // 当前页码
      pageSize: 10, // 每页数量
      pageTotal: 0,
    },
  }),
  mutations: {},
  actions: {
    async getIndexCompositionDataPageChange({ state, dispatch }, page) {
      state.getIndexCompositionDataObj.pageNo = page;

      await dispatch("getIndexCompositionData");
    },
    async getIndexCompositionData({ state }) {
      try {
        const res = await api["getIndexCompositionData"]({
          page: state.getIndexCompositionDataObj.pageNo,
          size: state.getIndexCompositionDataObj.pageSize,
        });

        state.getIndexCompositionDataList = res.data;

        state.getIndexCompositionDataObj.total = res.total;

        state.getIndexCompositionDataObj.pageTotal = Math.floor(
          (state.getIndexCompositionDataObj.total - 1) /
            state.getIndexCompositionDataObj.pageSize +
            1
        );
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {},
};
